import React from 'react';
import { WidgetSettings } from '../types/quiz';

interface ProfileHeaderProps {
  profileName: string;
  tagline: string;
  childName: string;
  settings: WidgetSettings;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ profileName, tagline, childName, settings }) => {
  return (
    <div className="rounded-lg p-5 sm:p-6 md:p-7 text-center mb-6 bg-white shadow-sm">
      <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-2 leading-tight">
        {childName} is a {profileName}
      </h1>
      <p className="text-sm sm:text-base md:text-lg text-gray-600">
        {tagline}
      </p>
    </div>
  );
};

export default ProfileHeader;
